<template>
  <div>
    <div class="checkout_container">
      <div class="checkout_container_header">
        <img
          src="@/assets/icons/back.svg"
          :class="[
            localDisplayLang === 'ara'
              ? 'checkout_container_header_back_rtl'
              : 'checkout_container_header_back',
          ]"
          @click="backBtn()"
        />
        <p class="checkout_container_header_title">{{ $t("Credit Card") }}</p>
      </div>
      <form
        @submit.prevent="paynow"
        id="payment-form"
        method="POST"
        action="https://merchant.com/charge-card"
      >
        <div class="form-group">
          <div v-if="formError" class="error-container">
            <p class="error">{{ formError }}</p>
          </div>
        </div>
        <div class="one-liner" v-if="!loader">
          <label for="card-number">{{ $t("Card number") }}</label>
          <div class="input-container card-number">
            <div class="icon-container">
              <img
                id="icon-card-number"
                src="@/assets/icons/card.svg"
                alt="PAN"
              />
            </div>
            <div
              class="card-number-frame"
              :class="[
                localDisplayLang === 'ara'
                  ? 'card-number-frame-ara'
                  : 'card-number-frame',
              ]"
            ></div>
            <div class="icon-container payment-method">
              <img id="logo-payment-method" />
            </div>
            <div class="icon-container">
              <img id="icon-card-number-error" src="@/assets/icons/error.svg" />
            </div>
          </div>

          <div class="date-and-code">
            <div>
              <label for="expiry-date">{{ $t("Expiry date") }}</label>
              <div
                class="input-container"
                :class="
                  localDisplayLang === 'ara' ? 'rtl-expiry-date' : 'expiry-date'
                "
              >
                <div class="icon-container">
                  <img
                    id="icon-expiry-date"
                    src="@/assets/icons/exp-date.svg"
                    alt="Expiry date"
                  />
                </div>
                <div
                  class="expiry-date-frame"
                  :class="[
                    localDisplayLang === 'ara'
                      ? 'expiry-date-frame-ara'
                      : 'expiry-date-frame',
                  ]"
                ></div>
                <div class="icon-container">
                  <img
                    id="icon-expiry-date-error"
                    src="@/assets/icons/error.svg"
                  />
                </div>
              </div>
            </div>

            <div>
              <label for="cvv">{{ $t("Security code") }}</label>
              <div class="input-container cvv">
                <div class="icon-container">
                  <img id="icon-cvv" src="@/assets/icons/cvv.svg" alt="CVV" />
                </div>
                <div
                  class="cvv-frame"
                  :class="[
                    localDisplayLang === 'ara' ? 'cvv-frame-ara' : 'cvv-frame',
                  ]"
                ></div>
                <div class="icon-container">
                  <img id="icon-cvv-error" src="@/assets/icons/error.svg" />
                </div>
              </div>
            </div>
          </div>

          <!-- add submit button -->
          <button class="button-primary primary-net5-button">
            {{ $t("SUBSCRIBE NOW") }}
          </button>

          <Loading class="form_loader" v-if="formLoader"></Loading>
        </div>
        <div v-else>
          <Loading></Loading>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { eventBus } from "@/eventBus";
import googleAnalytics from "@/mixins/googleAnalytics.js";
import facebookPixelAnalytics from "@/mixins/facebookPixelAnalytics.js";
import Utility from "@/mixins/Utility.js";
export default {
  props: {
    checkoutDetail: {
      type: Object,
    },
    paymentDetail: {
      type: Object,
    },
    finalPromoAmounts: {
      type: Object,
    },
    paymentPrecheckData: {
      type: Object,
    },
  },
  data() {
    return {
      formError: null,
      localDisplayLang: null,
      referenceData: null,
      formLoader: false,
      finalCost: null,
      frameLoader: true,
      promoCode: null,
      loader: false,
			planDiscountCheckout: null
    };
  },
  watch: {
    formError(val) {
      if (val) {
        setTimeout(() => {
          this.formError = null;
        }, 5000);
      }
    },
  },
  computed: {
    ...mapGetters(["getRtl", "appConfig"]),
	},
  created() {
    this.localDisplayLang = localStorage.getItem("setDisplayLanguageCode");

    eventBus.$on("paymentconfirmation-response", (response) => {
      if (response.reason) {
        this.formLoader = false;
        this.formError = response.reason;
      } else {
        if (response.redirect_url) {
          window.open(response.redirect_url, "_self");
        }
        this.formLoader = true;
      }
    });

    // this.paymentInit();
	this.planDiscountCheckout = this.appConfig.planDiscountCheckout;
    setTimeout(() => {
      this.initializeFrames();
    }, 100);
  },
  methods: {
    ...mapActions(["paymentInitiation", "paymentConfirmation"]),

    paymentInit() {
      console.log("what is the payment data ============", this.paymentDetail);
		let payload;
			if(this.paymentDetail.detail.planid === "C8I2TIVK"){
			   payload = {
        gatewayid: this.checkoutDetail.gatewayid,
        params: {
          amount: this.planDiscountCheckout.offerPrice,
          currency: this.paymentDetail.detail.currency,
          devicetype: "WEB",
          transactionpurpose: this.paymentDetail.transactionPurpose,
          transactionmode: "CC",
          availabilityid: this.paymentDetail.detail.availabilityset[0],
          planid: this.paymentDetail.detail.planid,
        },
      };
			}else {
			   payload = {
        gatewayid: this.checkoutDetail.gatewayid,
        params: {
          amount: this.finalPromoAmounts
            ? this.finalPromoAmounts.totalFinalCost
            : this.paymentPrecheckData.finalamount
            ? this.paymentPrecheckData.finalamount
            : this.paymentPrecheckData.amount,
          currency: this.paymentDetail.detail.currency,
          devicetype: "WEB",
          transactionpurpose: this.paymentDetail.transactionPurpose,
          transactionmode: "CC",
          availabilityid: this.paymentDetail.detail.availabilityset[0],
          planid: this.paymentDetail.detail.planid,
        },
      };
			}

      if (this.finalPromoAmounts && this.finalPromoAmounts.couponCode) {
        payload.params.couponid = this.finalPromoAmounts.couponCode;
      }

      this.loader = true;
      this.paymentInitiation(payload)
        .then((response) => {
          if (!response.reason) {
            this.loader = false;
            // setTimeout(() => {
            //   this.initializeFrames();
            // }, 100);
            this.referenceData = response.data;

            console.log("Reference Data", this.referenceData);

            let payload = {
              gatewayid: this.checkoutDetail.gatewayid,
              referencedata: this.referenceData,
              checkoutToken: this.checkoutToken,
            };

            console.log("checkoutCallback", payload);
            this.checkoutCallback(payload);

            console.log(
              "what is the reference data================",
              this.referenceData
            );

            const browser = this.getPlatformType();

            const theSource = localStorage.getItem("payment_source");

            let paymentDetailsForGA = {
              free_trial: this.getFreeTrial(),
              payment_mode: this.getPaymentMode(
                this.referenceData.referencedata.gwprovider
              ),
              plan_id: this.paymentDetail.detail.planid,
              plan_name: this.paymentDetail.detail.planname,
              payment_id: this.referenceData.referencedata.paymentid,
              source: theSource,
              object_id: "",
              object_name: "",
              platform: this.getPlatform(),
              platform_type: browser.browser,
            };

            // Google analytics Event
            this.subscriptionStarted(paymentDetailsForGA);

            // Facebook analytics event
            this.faceBookInitateCheckoutEvent(paymentDetailsForGA);
          } else {
            this.formError = response.reason;
          }
        })
        .catch((error) => console.log(error));
    },

    initializeFrames() {
      let self = this;

      Frames.init({
        publicKey: self.checkoutDetail.gwcredential.ApiPublicKey,
        localization: {
          cardNumberPlaceholder: "Card Number",
          expiryMonthPlaceholder: "MM",
          expiryYearPlaceholder: "YY",
          cvvPlaceholder: "CVV",
        },
        style: {
          base: {
            color: "white",
          },
          valid: {
            color: "green",
          },
          invalid: {
            color: "red",
          },
        },
      });

      Frames.addEventHandler(Frames.Events.CARD_TOKENIZED, function (event) {
        console.log("Card tokenization completed", event.token);
        self.checkoutToken = event.token;

        if (self.checkoutToken) {
          self.paymentInit();
        }

        // let payload = {
        //   gatewayid: self.checkoutDetail.gatewayid,
        //   referencedata: self.referenceData,
        //   checkoutToken: self.checkoutToken,
        // };

        // console.log("checkoutCallback", payload);
        // self.checkoutCallback(payload);
      });

      Frames.addEventHandler(
        Frames.Events.CARD_TOKENIZATION_FAILED,
        function () {
          self.onCardTokenizationFailed();
        }
      );

      // let form = document.getElementById("payment-form");

      // form.addEventListener("submit", function(event) {
      //   event.preventDefault();
      //   Frames.submitCard();
      // });
    },

    checkoutCallback(response) {
      let currentDomain = window.location.origin;
      let referencedata = response.referencedata;
      referencedata.referencedata.chargeid = response.checkoutToken;
      referencedata.referencedata.return_url =
        currentDomain +
        "/profile" +
        "?" +
        "planid=" +
        response.referencedata.referencedata.planid +
        "&" +
        "referenceid=" +
        response.referencedata.referenceid;

      let payload = {
        gatewayid: response.gatewayid,
        params: {
          referencedata: referencedata,
        },
      };

      eventBus.$emit("paymentConfirmation", payload);
    },

    onCardTokenizationFailed(error) {
      console.log("CARD_TOKENIZATION_FAILED: %o", error);
      Frames.enableSubmitForm();
    },

    generateLogos() {
      var logos = {};
      logos["card-number"] = {
        src: "card",
        alt: "card number logo",
      };
      logos["expiry-date"] = {
        src: "exp-date",
        alt: "expiry date logo",
      };
      logos["cvv"] = {
        src: "cvv",
        alt: "cvv logo",
      };
      return logos;
    },

    paynow() {
      if (!Frames.isCardValid()) {
        this.formError = "Enter valid card number";
      } else {
        this.formLoader = true;

        Frames.submitCard();

        // this.paymentInit();
      }
    },
    backBtn() {
      this.$emit("closeCheckout");
    },
  },
  beforeDestroy() {
    eventBus.$off("paymentconfirmation-response");
  },
  components: {
    Loading: () =>
      import(
        /* webpackChunkName: "Loading" */ "@/components/Templates/Loading.vue"
      ),
  },
  mixins: [Utility, googleAnalytics, facebookPixelAnalytics],
};
</script>

<style lang="scss" scoped>
@import "@/sass/_variables.scss";
@import "@/sass/_components.scss";
@import "./cardCheckout.scss"

</style>
